"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NoOpRunner", {
    enumerable: true,
    get: function() {
        return NoOpRunner;
    }
});
class NoOpRunner {
    async shouldRun() {
        return true;
    }
    async run() {
    // pass
    }
}
